import React, { useEffect } from "react";
import { useLoadingState } from "@/stores/ui/loadingState";

interface LodgeLoadingWrapperProps {
  children: React.ReactNode;
  loadingStates: Record<string, boolean>;
}

const LodgeLoadingWrapper: React.FC<LodgeLoadingWrapperProps> = ({
  children,
  loadingStates,
}) => {
  const { setLoadingState, isAnyLoading } = useLoadingState();

  useEffect(() => {
    // Set loading states
    Object.entries(loadingStates).forEach(([key, value]) => {
      setLoadingState(key, value);
    });
  }, [loadingStates, setLoadingState]);

  if (isAnyLoading()) {
    return (
      <div className="flex flex-col h-full w-full">
        {/* Header Bar Skeleton */}
        <div className="flex w-full flex-row items-center justify-between mb-2">
          <div className="h-8 w-48 bg-gray-200 rounded-md animate-pulse" />
          <div className="flex flex-row space-x-4 items-center">
            <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
            <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
            <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
          </div>
        </div>

        {/* Main Content Skeleton */}
        <div className="flex flex-row space-x-2 w-full h-[calc(100vh-3rem)]">
          {/* Social Feed Skeleton */}
          <div className="w-1/3 bg-white rounded-md p-4">
            <div className="h-8 w-3/4 bg-gray-200 rounded-md animate-pulse mb-4" />
            <div className="space-y-4">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="flex flex-col space-y-2">
                  <div className="h-4 w-full bg-gray-200 rounded-md animate-pulse" />
                  <div className="h-4 w-2/3 bg-gray-200 rounded-md animate-pulse" />
                </div>
              ))}
            </div>
          </div>

          {/* Main Content Area */}
          <div className="w-full h-full flex flex-col justify-between space-y-2.5">
            {/* Up Next Section Skeleton */}
            <div className="h-[55%] bg-white rounded-md p-4">
              <div className="h-8 w-1/4 bg-gray-200 rounded-md animate-pulse mb-4" />
              <div className="grid grid-cols-2 gap-4">
                {[...Array(4)].map((_, i) => (
                  <div
                    key={i}
                    className="h-24 bg-gray-200 rounded-md animate-pulse"
                  />
                ))}
              </div>
            </div>

            {/* Explore Card Section Skeleton */}
            <div className="h-[45%] bg-white rounded-md p-4">
              <div className="h-8 w-1/3 bg-gray-200 rounded-md animate-pulse mb-4" />
              <div className="grid grid-cols-3 gap-4">
                {[...Array(3)].map((_, i) => (
                  <div
                    key={i}
                    className="h-32 bg-gray-200 rounded-md animate-pulse"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default LodgeLoadingWrapper;
